export default "__VITE_ASSET__BCdamwO4__"